// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"854":"b746a074","959":"cb01f744","997":"514a7cb3"}[chunkId] + ".css";
};